module.exports = __webpack_public_path__ + "static/media/GDocsCustomerGuide.824b6548.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GDocsCustomerGuide.pdf
// module id = 92
// module chunks = 4